import { render } from "./ConfigurationTable.vue?vue&type=template&id=67262652&scoped=true"
import script from "./ConfigurationTable.vue?vue&type=script&lang=js"
export * from "./ConfigurationTable.vue?vue&type=script&lang=js"

import "./ConfigurationTable.vue?vue&type=style&index=0&id=67262652&scoped=true&lang=scss"

import exportComponent from "/build/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67262652"]])

export default __exports__